import { useContext, useEffect, useState } from 'react'
import { PropertiesContext } from 'context/propertiesContext'
import slugify from 'slugify'
import { useRouter } from 'next/router'

import styles from './propertiesSearchBar.module.css'


export default function PropertiesSearchBar() {
  const {
    numberProperties,
    cities,
    ufs,
    phases,
    citiesAll
  } = useContext(PropertiesContext)

  const [ufsData, setUfsData] = useState(ufs)
  const [citiesData, setCitiesData] = useState(cities)

  const [estado, setEstado] = useState({
    name: null,
    value: null
  })
  const [cidade, setCidade] = useState({
    name: null,
    value: null
  })
  const [fase, setFase] = useState({
    name: null,
    value: null
  })

  const router = useRouter()
  const query = []


  function handleOnChangeUf(e) {
    setEstado({
      name: 'ESTADO',
      value: e.target.value
    })

    setCidade({
      name: 'CIDADE',
      value: 'CIDADE'
    })
    
    if (e.target.value === 'ESTADO') {
      setCitiesData(cities)
      return
    }

    const citiesFilter = []

    citiesAll.forEach(item => {
      if (citiesFilter.some(e => e.nome.toLowerCase() === item.cidade.toLowerCase())) {
        return
      }

      if (item.uf.toLowerCase() === e.target.value.toLowerCase()) {
        citiesFilter.push({
          id: item.id,
          nome: item.cidade
        })
      }
    })

    setCitiesData(citiesFilter)
  }

  function handleOnChangeCities(e) {
    setCidade({
      name: 'CIDADE',
      value: e.target.value
    })

    if (e.target.value === 'CIDADE') {
      setCitiesData(cities)
      setEstado({
        name: 'ESTADO',
        value: 'ESTADO'
      })
      return
    }

    citiesAll.forEach(item => {
      if (item.cidade.toLowerCase() === e.target.value.toLowerCase()) {
        setEstado({
          name: 'ESTADO',
          value: item.uf
        })
      }
    })
  }

  async function handleSubmit(e) {
    e.preventDefault()

    const params = [estado, cidade, fase]

    params.map(item => {
      if (
        (
          item.value !== null &
          item.value !== 'ESTADO' &
          item.value !== 'CIDADE' &
          item.value !== 'FASE DO IMÓVEL'
        ) & query.length >= 1
      ) {
        const slug = slugify(item.value, { lower: true, remove: /percent/g, strict: true })
        query.push(`&${item.name}=${slug}`)
      }
      else if (
        (
          item.value !== null &
          item.value !== 'ESTADO' &
          item.value !== 'CIDADE' &
          item.value !== 'FASE DO IMÓVEL'
        ) & query.length === 0
      ) {
        const slug = slugify(item.value, { lower: true, remove: /percent/g, strict: true })
        query.push(`?${item.name}=${slug}`)
      }
    })

    router.push(query.join(''))
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.callText}>
          <div className={styles.parallelogramDetail} />
          <span>Imóveis à venda</span>
        </div>
        <div className={styles.searchBar}>
          <form onSubmit={(e) => handleSubmit(e)}>
            <span>USE O FILTRO E ENCONTRE SEU IMÓVEL</span>
            <div className={styles.selectBox}>
              <select value={estado.value} name="ESTADO" onChange={handleOnChangeUf}>
                <option
                  value={null}
                >
                  ESTADO
                </option>
                {
                  ufsData.map(uf => {
                    return (
                      <option value={uf.uf} key={uf.id}>
                        {uf.uf}
                      </option>
                    )
                  })
                }
              </select>
            </div>
            <div className={styles.selectBox}>
              <select value={cidade.value} name="CIDADE" onChange={handleOnChangeCities}>
                <option
                  value={null}
                >
                  CIDADE
                </option>
                {
                  citiesData.map(city => {
                    return (
                      <option value={city.nome} key={city.id}>
                        {city.nome}
                      </option>
                    )
                  })
                }
              </select>
            </div>
            <div className={styles.selectBox}>
              <select value={fase.value} name="FASE" onChange={(e) => setFase({
                name: e.target.name,
                value: e.target.value
              })}>
                <option
                  value={null}
                >
                  FASE DO IMÓVEL
                </option>
                {
                  phases.map(phase => {
                    return (
                      <option value={phase.fase} key={phase.id}>
                        {phase.fase}
                      </option>
                    )
                  })
                }
              </select>
            </div>
            <div className={styles.button}>
              <button type="submit">
                <span>BUSCAR</span>
                <img src="icons/lupa.svg" width={16} height={16} />
              </button>
            </div>
          </form>
        </div>
        <div className={styles.line} />
        <div className={styles.resultSearch}>
          <span>Resultado da busca:</span>
          <span>{numberProperties} imóveis</span>
        </div>
      </div>
    </>
  )
}
